<div class="container">
	<div id="translation-key-drop-down-filters" *ngIf="false">
		<mat-accordion>
			<mat-expansion-panel>
				<mat-expansion-panel-header>
					<mat-panel-title> Filter Options </mat-panel-title>
				</mat-expansion-panel-header>
				<div class="flex-container">
					<div class="type-button">
						<button id="translation-search-filter-bar-test-again-button" mat-raised-button>
							test again
						</button>
					</div>
				</div>
			</mat-expansion-panel>
		</mat-accordion>
	</div>

	<!--This should probally be it's own component-->
	<div class="translation-search-container">
		<form [formGroup]="textSearchForm" id="text-search-form" onSubmit="return false;">
			<!--Search Bar-->
			<ahs-text
				id="searchText"
				[ahsFormGroup]="textSearchForm"
				appearance="outline"
				[allowClear]="true"
				placeholder="ie. FORGOT_PASSWORD"
				label="Search Translation Data"
				*ngIf="textSearchForm"
			>
			</ahs-text>
			<!--Search Type Options-->
			<div id="key-search-options">
				<div>Change Searchable Field:</div>

				<ahs-radiolist
					id="searchType"
					[ahsFormGroup]="textSearchForm"
					appearance="outline"
					[options]="textSearchOptions"
					[flexFlow]="'row'"
					[rightOptionPadding]="'10px'"
				>
				</ahs-radiolist>
			</div>
		</form>
	</div>
	<!--End this should be its own component-->
</div>
